import { Step } from '../../types';
import { Flow } from '@lx/quote-tool/lite/shared/types';

/**
 * Strategy to get the step definition.
 * There will be as many strategies as steps in the application.
 */
export interface StepDefinitionStrategy {
  getStepDefinition(activeFlow?: Flow): Step;
}
